<template>
  <div class="row">
    <div class="col-12">
      <page-header
        :page="page"
        :has-save="true"
        :has-return="true"
        :has-add="false"
        @onSave="saveEvaluation"
        @onReturn="navigate"
      />

      <section-title :content="page.title" :has-line="true" />

      <evaluation-history-form
        ref="evaluationHistoryForm"
        :model="model"
        :service-types="serviceTypes"
        :valid-for="validForFlag"
        :max-length="maxLength"
      />
    </div>
  </div>
</template>

<script>
import { SectionTitle } from '@/components/pei/shared';
import alert from '@/mixin/alert.mixin';
import EvaluationHistoryForm from './components/StudentEvaluationHistoryForm';
import loading from '@/mixin/loading.mixin';
import PageHeader from '@/components/common/page/PageHeader';
import store from '@/store/index';
import serviceTypes from '@/utils/constants/service-types';
import validForFlag from '@/utils/constants/validForFlag';

export default {
  name: 'StudentEvaluationHistoryAdd',
  data: () => ({
    maxLength: 500,
    page: {
      icon: 'fas fa-file-alt',
      title: 'Añadir Evaluación',
      routes: ['Inicio', 'Estudiante', 'Evaluaciones'],
    },
    model: {
      date: new Date(),
      discipline: null,
      administrator: '',
      comment: '',
      documents: [],
      reevaluationRequired: false,
      reevaluationTime: null,
      reevaluationPeriod: null,
      reevaluationPurpose: null,
    },
    cameFromOutside: false,
    cameFromTab2: false,
    returnTo: { name: 'student-evaluation-history' },
    serviceTypes: {
      type: Array,
      default: () => [],
    },
    validForFlag: {
      type: Number,
      default: 0,
    },
    preRegId: null,
  }),
  components: {
    SectionTitle,
    PageHeader,
    EvaluationHistoryForm,
  },
  mixins: [alert, loading],
  async created() {
    this.validateRoute();
  },
  computed: {
    fromRoute() {
      return this.$router.app._route.params;
    },
    discussionMode() {
      return this.$route.query.discussionMode;
    },
  },
  methods: {
    validateRoute() {
      if (store.state.register != null) {
        this.cameFromOutside = true;
        this.returnTo = { name: `${store.state.register.pathName}` };
      } else if (
        this.$root.$route.params &&
        this.$root.$route.params.toward &&
        this.$root.$route.params.toward.query
      ) {
        let tab = this.$root.$route.params.toward.query.tab;
        this.cameFromTab2 = true; //Temp :S

        if (tab == 'Tab2') {
          this.validForFlag = validForFlag.Unset;
          this.serviceTypes = [serviceTypes.unSet];
        } else if (tab == 'RegistryEvaluationAndServices') {
          this.validForFlag = validForFlag.Registry;
          this.maxLength = 3000;
          this.serviceTypes = [];
          this.preRegId = this.$root.$route.params.toward.query.preRegistryId;
        }
      } else {
        this.cameFromOutside = false;
        this.validForFlag = validForFlag.Unset;
        this.serviceTypes = [serviceTypes.unSet];
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    async saveEvaluation() {
      const valid = await this.$refs['evaluationHistoryForm'].validation();

      if (!valid) {
        this.ShowToast(
          'Información Incompleta',
          'Favor de completar la información solicitada.',
          'error'
        );
        return;
      }

      const studentSieId = this.$route.query.studentSieId
        ? this.$route.query.studentSieId
        : store.getters.SelectedStudent.studentId;

      let formData = new FormData();
      formData.append('evaluationDate', this.model.date.toJSON());
      formData.append('disciplineTypeId', this.model.discipline.id);
      formData.append('evaluationDescription', this.model.comment);
      formData.append('evaluationAdministeredBy', this.model.administrator);
      formData.append('studentSieId', studentSieId);
      if (this.preRegId != undefined) {
        formData.append('regStudentId', this.preRegId);
      }

      const { file, type } = this.model.documents[0];
      formData.append('attachment', file);
      formData.append('fileName', file.name);
      formData.append('documentDate', file.lastModifiedDate.toJSON());
      formData.append('documentTypeId', type.id);
      formData.append('documentTitle', type.name);
      formData.append('reevaluationRequired', this.model.reevaluationRequired);

      if (this.model.reevaluationRequired) {
        formData.append(
          'reevaluationTime',
          this.model.concatenatedEvaluationTime.unitOfTime
        );
        formData.append(
          'reevaluationPeriodId',
          this.model.concatenatedEvaluationTime.reevaluationPeriodId
        );
        formData.append('reevaluationPurpose', this.model.reevaluationPurpose);
      }

      try {
        const { data } = await this.$ApiPost(
          '/api/studentEvaluation/SaveStudentEvaluation',
          formData
        );
        if (this.model.documents.length > 1) {
          this.saveDocuments(data.id);
        } else {
          this.ShowToast(
            'Proceso exitoso.',
            'Los datos fueron guardados exitosamente.',
            'success'
          );

          let fromView = this.$route.query.from;

          if (fromView) {
            const route = { path: fromView };
            if (this.discussionMode) route.query = { loadEvaluations: true };
            this.$router.push(route);
          } else if (this.cameFromOutside) {
            store.$dispatch('setRegisterEvaluation', this.model);
            this.$router.push(this.returnTo);
          } else if (this.cameFromTab2) {
            this.navigate();
          } else {
            this.$router.push({ name: 'student-evaluation-history' });
          }
        }
      } catch ({ response }) {
        if (response.status === 500) {
          const error = response.data.message;
          this.ShowToast('Aviso', error, 'error');
        }
      }
    },
    saveDocuments(evaluationId) {
      const makePromise = ({ file, type }) =>
        new Promise(() => {
          let formData = new FormData();
          formData.append('File', file);
          this.$ApiPost(
            `api/studentevaluation/${evaluationId}/document?documentTypeId=${type.id}`,
            formData
          );
        });

      this.model.documents.splice(0, 1);
      const promises = this.model.documents.map(makePromise);

      Promise.all(promises);

      this.ShowToast(
        'Proceso exitoso.',
        'Los datos fueron guardados exitosamente.',
        'success'
      );
      this.$router.push({ name: 'student-evaluation-history' });
    },
    navigate() {
      this.goBack();
    },
  },
};
</script>
